<template>
  <v-row>
    <v-col cols="6" sm="2">
      <decimal-number-input label="Cases" v-model="casesInput" :precision="0" integer prefix="" suffix="" :disabled="bottlesOnly"
                            :hint="estCases" persistent-hint/>
    </v-col>
    <v-col cols="6" sm="2">
      <decimal-number-input :label="bottlesLabel" v-model="bottlesInput" :precision="0" integer prefix="" suffix=""
                            :hint="estBottles" persistent-hint/>
    </v-col>
    <v-col cols="6" sm="2">
      <v-switch :label="`${bottlesLabel} only`" v-model="bottlesOnly" dense class="mt-1" @click="adjustQuantities()"/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'CasesBottles',
  props: {
    cases: {type:Number, required:true},
    bottles: {type:Number, required:true},
    product: {type:Object, required:true},
    availableCount: {type:Number, required:false},
    avaiablePrefix: {type:String, required:false, default:''},
    avaiableSuffix: {type:String, required:false, default:''}
  },
  data() {
    return {
      casesInput: this.cases,
      bottlesInput: this.bottles,
      bottlesOnly: false,
      estCases: '',
      estBottles: ''
    }
  },
  computed: {
    bottlesLabel() {
      return this.product.mixedPack ? 'Packs' : (this.product.containerType === 'Can' ? 'Cans' : 'Bottles');
    }
  },
  watch: {
    cases() {
      this.casesInput = this.cases;
    },
    bottles() {
      this.bottlesInput = this.bottles;
    },
    casesInput() {
      this.$emit('update:cases', this.casesInput);
      this.$emit('change');
    },
    bottlesInput() {
      this.$emit('update:bottles', this.bottlesInput);
      this.$emit('change');
    },
    availableCount() {
      this.available();
    }
  },
  methods: {
    adjustQuantities() {
      if (this.bottlesOnly) {
        this.bottlesInput += this.casesInput * this.product.caseSize;
        this.casesInput = 0;
      }
      else {
        this.casesInput = Math.floor(this.bottlesInput / this.product.caseSize);
        this.bottlesInput -= this.casesInput * this.product.caseSize;
      }
      this.available();
    },
    available() {
      if (this.product.caseSize && this.availableCount !== undefined) {
        const cases = this.bottlesOnly ? 0 : Math.floor(this.availableCount / this.product.caseSize);
        const bottles = this.availableCount - cases * this.product.caseSize;
        this.estCases = this.bottlesOnly ? '' : `${this.avaiablePrefix} ${cases} ${this.avaiableSuffix}`;
        this.estBottles = `${this.avaiablePrefix} ${bottles} ${this.avaiableSuffix}`;
      }
    }
  }
}
</script>